"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatorContainerMobile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _useCalculator = require("./hooks/useCalculator");
var _context = require("../../context");
var _ProgramDescriptionContainer = require("../ProgramDescriptionContainer/ProgramDescriptionContainer");
var _Container = require("../../components/Container");
var _Fields = require("../../components/Fields");
var _ProgramCarousel = require("../../components/ProgramCarousel");
var _ProgramModal = require("../../components/ProgramModal");
var _calculateMonthlyPayment = require("./utils/calculateMonthlyPayment");
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CalculatorContainerMobile = () => {
  const {
    title,
    priceTooltipTitle,
    priceTooltipText,
    escrowTooltipText,
    escrowTooltipTitle
  } = (0, _context.useAppContext)();
  const {
    programs,
    fields,
    selectedProgram,
    selectProgram,
    resetSelectedProgram,
    trackMortgageModalButtonClick,
    trackMortgageButtonClick
  } = (0, _useCalculator.useCalculator)();
  const {
    price,
    initialPayment,
    paymentPeriod,
    showEscrow
  } = fields;
  const {
    minRate,
    minPayment
  } = React.useMemo(() => {
    if (!programs.length) {
      return {
        minPayment: 0,
        minRate: 0
      };
    }
    const minRate = Math.min(...programs.map(_ref => {
      let {
        escrowRate,
        rate
      } = _ref;
      return (0, _utils.getRate)({
        showEscrow,
        escrowRate,
        rate
      });
    }));
    const minPayment = (0, _calculateMonthlyPayment.calculateMonthlyPayment)({
      price,
      initialPayment,
      years: paymentPeriod,
      rate: minRate
    });
    return {
      minRate,
      minPayment
    };
  }, [initialPayment, paymentPeriod, price, programs, showEscrow]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Container.ContainerMobile, {
    title: title,
    fields: /*#__PURE__*/React.createElement(_Fields.Fields, (0, _extends2.default)({}, fields, {
      priceTooltipTitle: priceTooltipTitle,
      priceTooltipText: priceTooltipText,
      escrowTooltipTitle: escrowTooltipTitle,
      escrowTooltipText: escrowTooltipText
    })),
    minRate: minRate,
    minPayment: minPayment,
    programs: programs.length ? /*#__PURE__*/React.createElement(_ProgramCarousel.ProgramCarousel, {
      showEscrow: showEscrow,
      items: programs,
      onProgramSelect: selectProgram
    }) : null,
    onMortgageButtonClick: trackMortgageButtonClick
  }), selectedProgram && /*#__PURE__*/React.createElement(_ProgramModal.ProgramModalMobile, (0, _extends2.default)({}, selectedProgram, {
    showEscrow: showEscrow,
    onClose: resetSelectedProgram,
    onMortgageButtonClick: trackMortgageModalButtonClick,
    description: /*#__PURE__*/React.createElement(_ProgramDescriptionContainer.ProgramDescriptionContainer, {
      description: selectedProgram.description
    })
  })));
};
exports.CalculatorContainerMobile = CalculatorContainerMobile;